import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import cn from 'classnames';
import { Button, TextField } from 'seagull';
import { Checkmark, CopyLiner24 } from 'seagull/icons';
import { useIoContext } from '~/contexts';
import styles from './CopyToClipboard.module.scss';
export function CopyToClipboard(props) {
    const { className, buttonClassname, textfieldClassname, value, onClick, onError, onCopy, buttonLabel, testId, size } = props, rest = _object_without_properties(props, [
        "className",
        "buttonClassname",
        "textfieldClassname",
        "value",
        "onClick",
        "onError",
        "onCopy",
        "buttonLabel",
        "testId",
        "size"
    ]);
    const resolvedTestId = testId || 'copy-to-clipboard';
    const { copyToClipboard } = useIoContext();
    const inputRef = useRef();
    const [isCopied, setIsCopied] = useState(false);
    const [hasError, setHasError] = useState(false);
    const ButtonWrapper = (param)=>{
        let { children } = param;
        return buttonClassname ? /*#__PURE__*/ _jsx("div", {
            className: buttonClassname,
            children: children
        }) : /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    };
    const TextfieldWrapper = (param)=>{
        let { children } = param;
        return textfieldClassname ? /*#__PURE__*/ _jsx("div", {
            className: textfieldClassname,
            children: children
        }) : /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.root, className),
        "data-testid": resolvedTestId,
        children: [
            /*#__PURE__*/ _jsx(TextfieldWrapper, {
                children: /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                    collapseHelperText: false,
                    size: size,
                    inputProps: {
                        readOnly: true
                    },
                    value: value,
                    inputRef: inputRef,
                    onClick: ()=>{
                        var _inputRef_current;
                        return (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.select();
                    },
                    onCopy: onCopy,
                    className: styles.input,
                    helperText: hasError ? 'Copy failed. Please try manually or give it another shot later.' : undefined,
                    error: hasError
                }, rest), {
                    testId: "".concat(resolvedTestId, "-input")
                }))
            }),
            /*#__PURE__*/ _jsx(ButtonWrapper, {
                children: /*#__PURE__*/ _jsx(Button, {
                    testId: "".concat(resolvedTestId, "-button"),
                    prefixIcon: isCopied ? /*#__PURE__*/ _jsx(Checkmark, {}) : /*#__PURE__*/ _jsx(CopyLiner24, {}),
                    onClick: ()=>{
                        try {
                            if (onClick) onClick();
                            if (!value) return;
                            copyToClipboard(value);
                            setIsCopied(true);
                            onCopy && onCopy();
                            setTimeout(()=>setIsCopied(false), 2000);
                        } catch (e) {
                            setHasError(true);
                            setTimeout(()=>setHasError(false), 2000);
                            if (onError) onError();
                        }
                    },
                    loading: !value,
                    disabled: isCopied,
                    className: styles.button,
                    children: isCopied ? 'Copied' : buttonLabel || 'Copy link'
                })
            })
        ]
    });
}
